var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    x: "0px",
    y: "0px",
    viewBox: "1.13 6.59 87.77 76.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.476,78.838,68.06,43.476,47.644,8.114a3.054,3.054,0,0,0-1.112-1.135l0,0a3.241,3.241,0,0,0-3-.035l-.061.037a3.054,3.054,0,0,0-1.112,1.135L21.94,43.476,1.524,78.838h0a3.1,3.1,0,0,0,1.114,4.184v0a3.053,3.053,0,0,0,1.533.387H85.833a3.075,3.075,0,0,0,1.471-.352l.061-.037a3.037,3.037,0,0,0,1.111-4.183Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangle);
export default __webpack_public_path__ + "static/media/icon-triangle.03fb16a5b3e512410aa89189a85df872.svg";
export { ForwardRef as ReactComponent };